@import '~style-sheet-helpers/core.less';

.package-type-dropdown {
  min-width: 200px;

  .package-type-dropdown-selector {
    border-radius: 4px;
    font-size: 13px;
    padding: 6px 5px 4px 10px;
  }
}
